import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Activity, BarChart3, Settings2, Users } from 'lucide-react';
import { PageHeader } from '@/components/ui/PageHeader';
import { TabBar } from '@/components/ui/TabBar';
import { useLayout } from '@/contexts/layout-context';
import { OverviewTab } from './overview-tab';
import { SessionsTab } from './sessions-tab';
import { ActivityTab } from './activity-tab';
import { SettingsTab } from './settings-tab';

const TABS = [
  { id: 'overview', label: 'Overview', icon: BarChart3 },
  { id: 'sessions', label: 'Sessions', icon: Users },
  { id: 'activity', label: 'Activity', icon: Activity },
  { id: 'settings', label: 'Settings', icon: Settings2 },
];

export const TokensPage = () => {
  const { setBreadcrumbs } = useLayout();
  const [params, setParams] = useSearchParams();
  const requested = params.get('tab') ?? 'overview';
  const active = TABS.some((t) => t.id === requested) ? requested : 'overview';

  useEffect(() => {
    setBreadcrumbs([{ name: 'Token Management' }]);
  }, [setBreadcrumbs]);

  return (
    <div className="p-4 lg:p-8 max-w-7xl mx-auto w-full animate-in fade-in duration-500">
      <PageHeader
        title="Token Management"
        subtitle="Token issuance and refreshes across tenants and identity providers, and how long sessions last."
      />

      <TabBar
        tabs={TABS}
        activeTab={active}
        onChange={(tab) => setParams({ tab }, { replace: true })}
        className="mb-6"
      />

      {active === 'overview' && <OverviewTab />}
      {active === 'sessions' && <SessionsTab />}
      {active === 'activity' && <ActivityTab />}
      {active === 'settings' && <SettingsTab />}
    </div>
  );
};
